import { Routes, Route } from "react-router-dom";

import {
  HOME_ROUTE,
  ABOUT_ROUTE,
  ADMISSION_ROUTE,
  FACILITY_ROUTE,
  CONTACT_ROUTE,
  CALENDAR_ROUTE,
  TRANSPORT_ROUTES,
  PRIVACY_ROUTE,
  TERMS_ROUTE,
} from "../constants/routes";

import Home from "../pages/Home";
import About from "../pages/About";
import Admission from "../pages/Admission";
import Facility from "../pages/Facility";
import Contact from "../pages/Contact";
import Calendar from "../pages/Calendar";
import TransportRoutes from "../pages/TransportRoutes";
import Privacy from "../pages/Privacy";
import Terms from "../pages/Terms";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path={HOME_ROUTE} element={<Home />} />
      <Route path={ABOUT_ROUTE} element={<About />} />
      <Route path={ADMISSION_ROUTE} element={<Admission />} />
      <Route path={FACILITY_ROUTE} element={<Facility />} />
      <Route path={CONTACT_ROUTE} element={<Contact />} />
      <Route path={CALENDAR_ROUTE} element={<Calendar />} />
      <Route path={TRANSPORT_ROUTES} element={<TransportRoutes />} />
      <Route path={PRIVACY_ROUTE} element={<Privacy />} />
      <Route path={TERMS_ROUTE} element={<Terms />} />
    </Routes>
  );
}
